"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionButton = exports.ToggleWrapper = void 0;
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const styled_components_1 = __importStar(require("styled-components"));
exports.ToggleWrapper = styled_components_1.default.div `
  background-color: #b0b7c3;
  border-radius: 10px;
  display: flex;
  align-items: center;
  height: 44px;
  width: 288px;
  padding: 4px;
  margin: 27px auto 30.89px;

  ${bitcoincom_pkg_theme_1.media.md `
    margin: 27px 0 30.89px;
  `}
`;
exports.OptionButton = styled_components_1.default.div `
  ${({ selected }) => (0, styled_components_1.css) `
    background-color: ${selected ? '#ffffff' : ''};
    border-radius: 8px;
    width: 141px;
    height: 44px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  `}

  input[type=radio] {
    position: fixed;
    opacity: 0;
    pointer-events: none;
  }

  &:first-child {
    margin-right: 8px;
  }

  & > span {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
  }

  & > img {
    margin-right: 8px;
  }
`;
//# sourceMappingURL=styled.js.map